import request from '@/request/store'
import type { IResponse } from '#/global'

export type commonTy = {
  userId?: string,
  region?: string,
  appId?: string
}
export type defaultTy = {
  token?: string,
}
export type PaymentReq = commonTy & defaultTy & {
  page: number,
  pageSize: number,
  cloudId: number
}
export type PaymentRes = {
  list: Payment[],
  page: number,
  page_size: number,
  total: number
}
export type Payment = {
  product_id: string,
  product_name: string,
  pay_price: string,
  vouch_time: string,
  charge_type: string
}
export type UserInfoReq = commonTy & defaultTy & {
}
export type UserInfoRes = {
  data: {
    name: string,
    address: string,
    phone_num: string,
    email: string,
    birthday: string,
    id_num: string,
    sign_date: string,
    sign_address: string
  }
}
export type verifyLoginReq = commonTy & {
  authCode: string,
  clientId: string
}

export type verifyLoginRes = {
  web_token: string
}
export type ProdListReq = commonTy & defaultTy & {
}

export type LimitProdReq = commonTy & defaultTy & {
  gameInfo: string
}

export type ProdListRes = {
  shelves_list: ShelvesItem[],
  pay_type_list: PayTypeItem[]
}
export type LimitProdRes = {
  prod_buy_detail: LimitProdItem[],
}
export type ShelvesItem = {
  shelves_name: string,
  shelves_desc: string,
  prod_list: ProdItem[]
}
export type ProdItem = {
  shelves_name: string,
  shelves_icon: string,
  prod_id: string,
  prod_name: string,
  prod_icon: string,
  prod_currency: string,
  prod_price: number,
  prod_bonus?: string,
  prod_limit?: string,
  app_id: string,
  region: string,
  extra_info: string,
  limit?: number,
  buy_count?: number,
}
export type PayTypeItem = {
  pay_type: string,
  icon: string,
  extra_info: string,
  region: string
}
export type LimitProdItem = {
  prod_id: string,
  limit: number,
  buy_count: number,
}
export type MakeOrderReq = commonTy & defaultTy & {
  clientId: string,
  prodId: string,
  chargeType: string
}
export type MakeOrderRes = {
  orderId: string
}
export type ShopTextRes = {
  message: string
}
export const getPaymentApi = (params: PaymentReq): Promise<IResponse<PaymentRes>> => {
  return request.get({ url: '/api/tyoffice-pay-server/h5service/v1/purchaseRecords', params })
}

export const getUserInfoApi = (params: UserInfoReq): Promise<IResponse<UserInfoRes>> => {
  return request.get({ url: '/api/tyoffice-pay-server/accountservice/v1/realNameInfo', params })
}

export const getProdListApi = (params: ProdListReq): Promise<IResponse<ProdListRes>> => {
  return request.get({ url: '/api/tyoffice-pay-server/h5service/v1/prodList', params })
}
export const getlimitProdApi = (data: LimitProdReq): Promise<IResponse<LimitProdRes>> => {
  return request.post({ url: '/api/tyoffice-pay-server/h5service/v1/limitProdBuyDetail', data })
}

export const verifyLoginApi = (data: verifyLoginReq): Promise<IResponse<verifyLoginRes>> => {
  return request.post({ url: '/api/tyoffice-pay-server/accountservice/v1/verifyAuthCode', data })
}

export const makeOrderApi = (params: MakeOrderReq): Promise<IResponse<MakeOrderRes>> => {
  return request.get({ url: '/api/tyoffice-pay-server/h5service/v1/makeOrder', params })
}

export const getShopTextApi = (): Promise<ShopTextRes> => {
  return fetch('https://globalqn.qijihdhk.com/hwglobal/buyuPreheat/website/vn/shop.json',
    { method: 'GET' }).then(response => {
      return response.json();
    })
}